// 引入依赖
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "@/views/LoginView";
import UserView from "@/views/UserView";
import KamilView from "@/views/KamilView";
import { Message } from 'element-ui';
import ApiKeysView from "@/views/ApiKeysView";
import OrderView from "@/views/OrderView";
import ConfigView from "@/views/ConfigView";
import TipsView from "@/views/TipsView";
import ClaudeView from "@/views/ClaudeView";
import RechargeView from "@/views/RechargeView";
import TavernView from "@/views/tavernView.vue";
import JingXiangRechargeView from "@/views/JingXiangRechargeView.vue";
import SillyApiKeysPage from "@/views/SillyApiKeysPage.vue";
import SillyTokenInfoPage from "@/views/SillyTokenInfoPage.vue";
import NaiPointApi from "@/views/NaiPointApi.vue";
import UserApi from "@/views/UserApi.vue";
import ProxyConfigView from "@/views/ProxyConfigView.vue";
// 假设你有一个Message组件用来显示提示信息

// 使用VueRouter
Vue.use(VueRouter)

// 路由定义
const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/user',
    name: 'user',
    component: UserView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/kamil',
    name: 'kamil',
    component: KamilView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Apikey',
    name: 'Apikey',
    component: ApiKeysView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Claude',
    name: 'Claude',
    component: ClaudeView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Order',
    name: 'Order',
    component: OrderView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Config',
    name: 'Config',
    component: ConfigView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Tips',
    name: 'Tips',
    component: TipsView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/Recharge',
    name: 'Recharge',
    component: RechargeView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/JingXiangRecharge',
    name: 'JingXiangRecharge',
    component: JingXiangRechargeView,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/SillyApiKeysPage',
    name: 'SillyApiKeysPage',
    component: SillyApiKeysPage,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/SillyTokenInfoPage',
    name: 'SillyTokenInfoPage',
    component: SillyTokenInfoPage,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/SillyTokenInfoPage',
    name: 'SillyTokenInfoPage',
    component: SillyTokenInfoPage,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/NaiPointApi',
    name: 'NaiPointApi',
    component: NaiPointApi,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/UserApi',
    name: 'UserApi',
    component: UserApi,
    meta: { requiresAuth: true } // 表明需要验证
  },
  {
    path: '/ProxyConfigView',
    name: 'ProxyConfigView',
    component: ProxyConfigView,
    meta: { requiresAuth: true } // 表明需要验证
  }
]

// 创建router实例
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// Set Cookie
function setCookie(name, value, expiration) {
  const expires = new Date();
  expires.setTime(expires.getTime() + expiration);

  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

// Get Cookie
function getCookie(name) {
  const cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=');
    const cookieName = cookiePair[0].trim();

    if (cookieName === name) {
      return cookiePair[1];
    }
  }

  return null;
}

// Delete Cookie
function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getCookie('token');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ path: '/' });
      Message({
        message: '请先登录！',
        type: 'warning',
        duration: 5000
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

// 导出router实例
export default router